// extracted by mini-css-extract-plugin
export default {"headers":"Table_headers__xYG38"};